import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, Eye } from "lucide-react";
import { blogService } from "../../services/blog.service";
import styles from "./Admin.module.css";

const AdminBlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadBlogs = async () => {
    setLoading(true);
    const data = await blogService.getBlogs({ includeDrafts: true });
    setBlogs(data);
    setLoading(false);
  };

  useEffect(() => {
    loadBlogs();
  }, []);

  const handleDelete = async (blog) => {
    const confirmed = window.confirm(`Delete “${blog.title}”? This will hide it from the website.`);
    if (!confirmed) return;

    await blogService.deleteBlog(blog.id);
    loadBlogs();
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div>
          <h1>Blogs</h1>
          <p>Write a new story, upload a banner, and add photos inside the article.</p>
        </div>
        <Link to="/admin/blogs/new" className={styles.primaryBtn}>
          <Plus size={18} />
          New blog
        </Link>
      </div>

      {loading ? (
        <div className={styles.emptyState}>Loading blogs...</div>
      ) : blogs.length === 0 ? (
        <div className={styles.emptyState}>
          <h2>No blogs yet</h2>
          <p className={styles.hint}>Create the first article and it will appear on the public Blogs page.</p>
        </div>
      ) : (
        <div className={styles.grid}>
          {blogs.map((blog) => (
            <article className={styles.card} key={blog.id}>
              <div className={styles.cardImage}>
                {blog.image ? <img src={blog.image} alt={blog.title} /> : null}
              </div>
              <div className={styles.cardBody}>
                <div className={styles.meta}>
                  <span className={styles.badge}>{blog.category}</span>
                  {blog.featured ? <span className={styles.badge}>Featured</span> : null}
                  {!blog.published ? <span className={styles.badge}>Draft</span> : null}
                </div>
                <h2>{blog.title}</h2>
                <p>{blog.shortDescription}</p>
                <div className={styles.cardActions}>
                  <Link to={`/blogs/${blog.slug}`} className={styles.secondaryBtn} target="_blank" rel="noreferrer">
                    <Eye size={16} />
                    View
                  </Link>
                  <Link to={`/admin/blogs/${blog.id}/edit`} className={styles.secondaryBtn}>
                    <Pencil size={16} />
                    Edit
                  </Link>
                  <button type="button" className={styles.dangerBtn} onClick={() => handleDelete(blog)}>
                    <Trash2 size={16} />
                    Delete
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminBlogsPage;
